<template>
  <v-container fluid>
    <!-- Encabezado -->
    <v-row align="center" class="mb-1">
      <v-col>
        <h2 class="headline font-weight-bold">
          <v-icon :color="colorTema" large class="mr-2">mdi-image-multiple</v-icon>
          {{ tituloPanel }}
        </h2>
      </v-col>
      <v-col cols="auto" v-if="verSelectorInstancia">
        <v-select
          v-model="instanciaSeleccionada"
          :items="[{text: 'INBI', value: 'inbi'}, {text: 'FAST', value: 'fast'}]"
          label="Instancia"
          outlined
          dense
          hide-details
        />
      </v-col>
    </v-row>

    <!-- Tabs principales -->
    <v-tabs v-model="tab" :color="colorTema" background-color="transparent" class="mb-4">
      <v-tab><v-icon left small>mdi-folder-multiple-image</v-icon>Galería</v-tab>
      <v-tab><v-icon left small>mdi-cog</v-icon>Administración</v-tab>
      <v-tab><v-icon left small>mdi-format-list-bulleted</v-icon>Catálogos</v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">

      <!-- ══════════════════════════════════════════════
           TAB 0 — GALERÍA
      ══════════════════════════════════════════════ -->
      <v-tab-item>
        <v-card class="mb-4 pa-3">
          <v-row dense align="center">
            <v-col cols="12" md="2">
              <v-select v-model="gal.ciclo" :items="ciclosVisibles" item-text="ciclo" item-value="id"
                label="Ciclo" outlined dense hide-details clearable @change="getRecursos" />
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="gal.sucursal" :items="sucursalesList" item-text="nombre" item-value="id"
                label="Sucursal" outlined dense hide-details clearable @change="getRecursos" />
            </v-col>
            <v-col cols="12" md="2">
              <v-select v-model="gal.tipo" :items="tipos" item-text="nombre" item-value="id" label="Tipo" outlined dense
                hide-details clearable @change="getRecursos" />
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="gal.usos" :items="usos" item-text="nombre" item-value="id"
                label="Uso (múltiple)" outlined dense hide-details multiple clearable @change="getRecursos">
                <template v-slot:selection="{ item, index }">
                  <v-chip x-small v-if="index < 2">{{ item.nombre }}</v-chip>
                  <span v-if="index === 2" class="grey--text caption">(+{{ gal.usos.length - 2 }})</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn text small @click="limpiarGal">
                <v-icon left small>mdi-filter-off</v-icon>Limpiar
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-row v-if="!cargandoRecursos && recursos.length">
          <v-col v-for="item in recursos" :key="item.id" cols="12" sm="6" md="4" lg="3">
            <v-card outlined hover>
              <v-img v-if="esImagen(item.url)" :src="getUrl(item.url)" height="160" cover>
                <template v-slot:placeholder><v-skeleton-loader type="image" /></template>
              </v-img>
              <v-sheet v-else height="160" color="grey lighten-4" class="d-flex align-center justify-center">
                <v-icon size="64" :color="esPdf(item.url) ? 'red' : 'blue'">
                  {{ esPdf(item.url) ? 'mdi-file-pdf-box' : 'mdi-video' }}
                </v-icon>
              </v-sheet>
              <v-card-title class="subtitle-2 pa-2">{{ item.nombre }}</v-card-title>
              <v-card-subtitle class="pa-2 pt-0 caption grey--text">
                {{ item.ciclo_nombre || 'Todos' }} · {{ item.sucursal_nombre || 'Todas' }} · {{ item.tipo_nombre }} · {{ item.uso_nombre }}
              </v-card-subtitle>
              <v-card-actions class="pa-2">
                <v-spacer />
                <v-btn small text @click="abrirVisor(item)">
                  <v-icon left small>mdi-eye</v-icon>Ver
                </v-btn>
                <v-btn small text @click="descargarArchivo(item.url, item.nombre)">
                  <v-icon left small>mdi-download</v-icon>Descargar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else-if="cargandoRecursos">
          <v-col v-for="n in 8" :key="n" cols="12" sm="6" md="4" lg="3">
            <v-skeleton-loader type="card" />
          </v-col>
        </v-row>
        <v-row v-else>
          <v-col cols="12" class="text-center pa-8 grey--text">
            <v-icon size="64" class="mb-3">mdi-image-off-outline</v-icon>
            <div>Sin recursos para los filtros seleccionados</div>
          </v-col>
        </v-row>
      </v-tab-item>

      <!-- ══════════════════════════════════════════════
           TAB 1 — ADMINISTRACIÓN
      ══════════════════════════════════════════════ -->
      <v-tab-item>
        <v-row class="mb-3 px-2 py-2" align="center" >
          <v-col><span class="grey--text caption">Subida, edición, clonación y borrado de recursos</span></v-col>
          <v-col class="d-flex justify-end">
            <v-btn :color="colorTema" class="white--text" @click="abrirSubida">
              <v-icon left>mdi-upload</v-icon>Subir recurso
            </v-btn>
          </v-col>
        </v-row>

        <v-card class="mb-4 pa-3">
          <v-row dense align="center">
            <v-col cols="12" md="2">
              <v-select v-model="adm.ciclo" :items="ciclosVisibles" item-text="ciclo" item-value="id"
                label="Ciclo" outlined dense hide-details clearable @change="getRecursosAdmin" />
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="adm.sucursal" :items="sucursalesList" item-text="nombre" item-value="id"
                label="Sucursal" outlined dense hide-details clearable @change="getRecursosAdmin" />
            </v-col>
            <v-col cols="12" md="2">
              <v-select v-model="adm.tipo" :items="tipos" item-text="nombre" item-value="id" label="Tipo" outlined dense
                hide-details clearable @change="getRecursosAdmin" />
            </v-col>
            <v-col cols="12" md="3">
              <v-select v-model="adm.usos" :items="usos" item-text="nombre" item-value="id" label="Uso (múltiple)"
                outlined dense hide-details multiple clearable @change="getRecursosAdmin">
                <template v-slot:selection="{ item, index }">
                  <v-chip x-small v-if="index < 2">{{ item.nombre }}</v-chip>
                  <span v-if="index === 2" class="grey--text caption">(+{{ adm.usos.length - 2 }})</span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="2">
              <v-btn text small @click="limpiarAdm">
                <v-icon left small>mdi-filter-off</v-icon>Limpiar
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-card>
          <v-data-table :headers="headersAdm" :items="recursosAdmin" :loading="cargandoAdmin"
            loading-text="Cargando recursos..." no-data-text="Sin recursos" :items-per-page="20">
            <template v-slot:item.url="{ item }">
              <v-avatar tile size="48" class="my-1">
                <v-img v-if="esImagen(item.url)" :src="getUrl(item.url)" />
                <v-icon v-else-if="esPdf(item.url)" color="red">mdi-file-pdf-box</v-icon>
                <v-icon v-else color="blue">mdi-video</v-icon>
              </v-avatar>
            </template>
            <template v-slot:item.acciones="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }"><v-btn icon small v-on="on" @click="abrirEdicion(item)"><v-icon
                      small>mdi-pencil</v-icon></v-btn></template>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }"><v-btn icon small v-on="on" @click="abrirClonar(item)"><v-icon
                      small>mdi-content-copy</v-icon></v-btn></template>
                <span>Clonar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }"><v-btn icon small color="red" v-on="on"
                    @click="confirmarBorrar(item)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></template>
                <span>Borrar</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <!-- ══════════════════════════════════════════════
           TAB 2 — CATÁLOGOS
      ══════════════════════════════════════════════ -->
      <v-tab-item>
        <v-tabs v-model="catTab" :color="colorTema" class="mb-3">
          <v-tab>Ciclos</v-tab>
          <v-tab>Tipos</v-tab>
          <v-tab>Usos</v-tab>
        </v-tabs>

        <v-tabs-items v-model="catTab">
          <!-- Ciclos -->
          <v-tab-item>
            <v-card>
              <v-card-text>
                <v-data-table :headers="headersCiclos" :items="ciclosList" :loading="cargandoCiclos"
                  loading-text="Cargando..." no-data-text="Sin ciclos" hide-default-footer :items-per-page="-1">
                  <template v-slot:item.visible="{ item }">
                    <v-switch v-model="item.visible" :true-value="1" :false-value="0" color="success" inset dense
                      hide-details @change="toggleVisibilidad(item)" />
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Tipos -->
          <v-tab-item>
            <v-row class="mb-2 mt-1 px-1" align="center">
              <v-col cols="12" md="6">
                <v-text-field v-model="nuevoTipo" label="Nuevo tipo" outlined dense hide-details
                  @keyup.enter="addTipo" />
              </v-col>
              <v-col cols="auto">
                <v-btn color="primary" :loading="guardando" @click="addTipo">
                  <v-icon left>mdi-plus</v-icon>Agregar
                </v-btn>
              </v-col>
            </v-row>
            <v-card>
              <v-card-text>
                <v-data-table :headers="headersCat" :items="tiposList" :loading="cargandoTipos"
                  loading-text="Cargando..." no-data-text="Sin tipos" hide-default-footer :items-per-page="-1">
                  <template v-slot:item.activo="{ item }">
                    <v-chip small :color="item.activo ? 'success' : 'grey'" dark>{{ item.activo ? 'Activo' : 'Inactivo'
                      }}</v-chip>
                  </template>
                  <template v-slot:item.acciones="{ item }">
                    <v-btn icon small color="red" :disabled="!item.activo" @click="deactivateTipo(item)">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <!-- Usos -->
          <v-tab-item>
            <v-row class="mb-2 mt-1 px-1" align="center">
              <v-col cols="12" md="6">
                <v-text-field v-model="nuevoUso" label="Nuevo uso" outlined dense hide-details @keyup.enter="addUso" />
              </v-col>
              <v-col cols="auto">
                <v-btn color="primary" :loading="guardando" @click="addUso">
                  <v-icon left>mdi-plus</v-icon>Agregar
                </v-btn>
              </v-col>
            </v-row>
            <v-card>
              <v-card-text>
                <v-data-table :headers="headersCat" :items="usosList" :loading="cargandoUsos" loading-text="Cargando..."
                  no-data-text="Sin usos" hide-default-footer :items-per-page="-1">
                  <template v-slot:item.activo="{ item }">
                    <v-chip small :color="item.activo ? 'success' : 'grey'" dark>{{ item.activo ? 'Activo' : 'Inactivo'
                      }}</v-chip>
                  </template>
                  <template v-slot:item.acciones="{ item }">
                    <v-btn icon small color="red" :disabled="!item.activo" @click="deactivateUso(item)">
                      <v-icon small>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tab-item>
    </v-tabs-items>

    <!-- ══════ DIALOGS ══════ -->
    <v-dialog v-model="dlgSubida" max-width="560" persistent>
      <v-card>
        <v-card-title>{{ modoEdicion ? 'Editar recurso' : 'Subir recurso' }}</v-card-title>
        <v-card-text>
          <v-form ref="formSubida">
            <v-text-field v-model="form.nombre" label="Nombre *" outlined dense
              :rules="[function (v) { return !!v || 'Requerido' }]" />
            <v-select v-model="form.id_ciclo" :items="ciclosVisibles" item-text="ciclo" item-value="id"
              label="Ciclo *" outlined dense :rules="[function (v) { return !!v || 'Requerido' }]" />
            <v-select v-model="form.id_sucursal" :items="sucursalesList" item-text="nombre" item-value="id"
              label="Sucursal (Opcional - Aplica a todas)" outlined dense clearable />
            <v-select v-model="form.id_tipo" :items="tipos" item-text="nombre" item-value="id" label="Tipo *" outlined
              dense :rules="[function (v) { return !!v || 'Requerido' }]" />
            <v-select v-model="form.id_uso" :items="usos" item-text="nombre" item-value="id" label="Uso *" outlined
              dense :rules="[function (v) { return !!v || 'Requerido' }]" />
            <v-file-input v-if="!modoEdicion" v-model="form.archivo"
              label="Archivo (max. 100 MB — .mp4 · .jpg · .png · .pdf)" outlined dense
              accept=".mp4,.jpg,.jpeg,.png,.pdf" show-size
              :rules="[function (v) { return !!v || 'Requerido' }, function (v) { return !v || v.size <= 104857600 || 'Supera 100 MB' }]" />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dlgSubida = false">Cancelar</v-btn>
          <v-btn :color="colorTema" class="white--text" :loading="guardando" @click="guardar">
            {{ modoEdicion ? 'Guardar' : 'Subir' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgClonar" max-width="400">
      <v-card>
        <v-card-title>Clonar recurso</v-card-title>
        <v-card-text>
          <v-select v-model="cicloClon" :items="ciclosVisibles" item-text="ciclo" item-value="id"
            label="Ciclo destino *" outlined dense />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dlgClonar = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="guardando" @click="clonar">Clonar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgBorrar" max-width="380">
      <v-card>
        <v-card-title>¿Borrar recurso?</v-card-title>
        <v-card-text>El archivo cambiará a estado <b>eliminado</b> sin borrarse del servidor.</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dlgBorrar = false">Cancelar</v-btn>
          <v-btn color="red" dark :loading="guardando" @click="borrar">Borrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dlgVisor" max-width="800">
      <v-card v-if="recursoVisor">
        <v-card-title class="pa-3 justify-space-between">
          <span class="subtitle-1 font-weight-bold">{{ recursoVisor.nombre }}</span>
          <v-btn icon @click="dlgVisor = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 bg-grey-lighten-4 text-center d-flex align-center justify-center" style="min-height: 300px;">
          <v-img v-if="esImagen(recursoVisor.url)" :src="getUrl(recursoVisor.url)" contain max-height="70vh" />
          <video v-else-if="!esPdf(recursoVisor.url)" controls autoplay style="width: 100%; max-height: 70vh; background: black;">
            <source :src="getUrl(recursoVisor.url)" type="video/mp4" />
            Tu navegador no soporta la reproducción de video.
          </video>
          <v-sheet v-else height="300" class="d-flex flex-column align-center justify-center w-100">
            <v-icon size="80" color="red" class="mb-4">mdi-file-pdf-box</v-icon>
            <v-btn color="red" dark @click="abrirArchivo(recursoVisor.url)">Abrir PDF en nueva pestaña</v-btn>
          </v-sheet>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snack.show" :color="snack.color" top right timeout="4000" class="text-center px-2"> {{ snack.text }}</v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex/dist/vuex.common.js';
export default {
  name: 'Multimedia',
  data() {
    return {
      instanciaOverride: null,
      tab: 0,
      catTab: 0,
      tipos: [],
      usos: [],
      gal: { ciclo: null, sucursal: null, tipo: null, usos: [] },
      recursos: [],
      cargandoRecursos: false,
      adm: { ciclo: null, sucursal: null, tipo: null, usos: [] },
      recursosAdmin: [],
      cargandoAdmin: false,
      headersAdm: [
        { text: '', value: 'url', width: 70, sortable: false },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Ciclo', value: 'ciclo_nombre' },
        { text: 'Sucursal', value: 'sucursal_nombre' },
        { text: 'Tipo', value: 'tipo_nombre' },
        { text: 'Uso', value: 'uso_nombre' },
        { text: 'Fecha', value: 'fecha_alta', width: 140 },
        { text: 'Acciones', value: 'acciones', width: 130, sortable: false },
      ],
      dlgSubida: false, modoEdicion: false, recursoEdit: null,
      form: { nombre: '', id_ciclo: null, id_sucursal: null, id_tipo: null, id_uso: null, archivo: null },
      dlgClonar: false, recursoClonar: null, cicloClon: null,
      dlgBorrar: false, recursoBorrar: null,
      dlgVisor: false, recursoVisor: null,
      guardando: false,
      sucursalesList: [],
      ciclosList: [], cargandoCiclos: false,
      tiposList: [], cargandoTipos: false,
      usosList: [], cargandoUsos: false,
      nuevoTipo: '', nuevoUso: '',
      headersCiclos: [
        { text: 'Ciclo', value: 'ciclo' },
        { text: 'Inicio', value: 'fecha_inicio_ciclo' },
        { text: 'Fin', value: 'fecha_fin_ciclo' },
        { text: 'Visible', value: 'visible', width: 120 },
      ],
      headersCat: [
        { text: 'ID', value: 'id', width: 80 },
        { text: 'Nombre', value: 'nombre' },
        { text: 'Estado', value: 'activo', width: 120 },
        { text: '', value: 'acciones', width: 80, sortable: false },
      ],
      snack: { show: false, text: '', color: 'success' },
    };
  },
  computed: {
    ...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),
    idUsuario() { return this.getdatosUsuarioERPERP.iderp; },
    idPuesto() { return this.getdatosUsuarioERPERP.idpuesto; },
    ciclosVisibles() { return this.ciclosList.filter(function (c) { return c.visible; }); },
    verSelectorInstancia() { return [12, 40, 48, 113, 101,48,49,62,25,74,97,54].includes(Number(this.idPuesto)); },
    inst() { 
      if (this.instanciaOverride) return this.instanciaOverride;
      return Number(this.getEscuela) === 1 ? 'inbi' : 'fast'; 
    },
    instanciaSeleccionada: {
      get() { return this.inst; },
      set(val) { this.instanciaOverride = val; }
    },
    colorTema() { return this.inst === 'inbi' ? 'purple darken-2' : 'blue darken-2'; },
    tituloPanel() { return this.inst === 'inbi' ? 'Recursos Multimedia — INBI' : 'Recursos Multimedia — FAST'; }
  },
  watch: {
    tab: function (val) {
      if (val === 0) this.getRecursos();
      if (val === 1) this.getRecursosAdmin();
      if (val === 2) this.cargarCatalogos();
    },
    catTab: function (val) {
      // Opcionalmente podemos forzar refresco de catalogos si cambia interno
      // pero por lo general cargarCatalogos() trae todos al instante.
      // this.cargarCatalogos(); 
    },
    inst: function () {
      this.cargarBase();
      if (this.tab === 0) this.getRecursos();
      else if (this.tab === 1) this.getRecursosAdmin();
      else if (this.tab === 2) this.cargarCatalogos();
    }
  },
  methods: {
    async cargarBase() {
      var rC = await this.$http.get('multimedia.ciclos.list?inst=' + this.inst);
      var rS = await this.$http.get('multimedia.sucursales.list?inst=' + this.inst);
      var rT = await this.$http.get('multimedia.tipos.list?inst=' + this.inst);
      var rU = await this.$http.get('multimedia.usos.list?inst=' + this.inst);
      this.ciclosList = rC.data.map(function (c) { 
        return Object.assign({}, c, { 
          visible: Number(c.visible) 
        }); 
      });
      this.sucursalesList = rS.data;
      this.tipos = rT.data;
      this.usos = rU.data;
      if (this.ciclosVisibles.length) this.gal.ciclo = this.ciclosVisibles[0].id_ciclo;
    },

    async cargarCatalogos() {
      this.cargandoCiclos = true;
      this.cargandoTipos = true;
      this.cargandoUsos = true;
      try {
        var rC = await this.$http.get('multimedia.ciclos.list?inst=' + this.inst);
        var rS = await this.$http.get('multimedia.sucursales.list?inst=' + this.inst);
        var rT = await this.$http.get('multimedia.tipos.admin?inst=' + this.inst);
        var rU = await this.$http.get('multimedia.usos.admin?inst=' + this.inst);

        this.ciclosList = rC.data.map(function (c) { 
          return Object.assign({}, c, { visible: Number(c.visible) }); 
        });
        this.sucursalesList = rS.data;
        this.tiposList = rT.data; this.usosList = rU.data;
        this.tipos = this.tiposList.filter(function (t) { return t.activo; });
        this.usos = this.usosList.filter(function (u) { return u.activo; });
      } catch (e) { 
        this.showSnack('Error al cargar catálogos', 'error'); 
      }
      finally { 
        this.cargandoCiclos = false; 
        this.cargandoTipos = false; 
        this.cargandoUsos = false; 
      }
    },

    async getRecursos() {
      this.cargandoRecursos = true;
      try {
        var res = await this.$http.get('multimedia.recursos.list', {
          params: { 
            inst: this.inst, 
            ciclo: this.gal.ciclo, 
            sucursal: this.gal.sucursal,
            tipo: this.gal.tipo, 
            usos: this.gal.usos.join(',') 
          }
        });
        this.recursos = res.data;
      } catch (e) { 
        this.showSnack('Error al cargar galería', 'error'); 
      }
      finally { this.cargandoRecursos = false; }
    },
    
    limpiarGal() { 
      this.gal = { 
        ciclo: null, 
        sucursal: null,
        tipo: null, 
        usos: [] 
      }; 
      this.getRecursos(); 
    },

    async getRecursosAdmin() {
      this.cargandoAdmin = true;
      try {
        var res = await this.$http.get('multimedia.recursos.list', {
          params: { 
            inst: this.inst, 
            ciclo: this.adm.ciclo, 
            sucursal: this.adm.sucursal,
            tipo: this.adm.tipo, 
            usos: this.adm.usos.join(',') 
          }
        });
        this.recursosAdmin = res.data;
      } catch (e) { 
        this.showSnack('Error al cargar recursos', 'error'); 
      }
      finally { this.cargandoAdmin = false; }
    },

    limpiarAdm() { 
      this.adm = { 
        ciclo: null, 
        sucursal: null,
        tipo: null, 
        usos: [] 
      }; 
      this.getRecursosAdmin(); 
    },

    abrirSubida() {
      this.modoEdicion = false;
      this.form = { nombre: '', id_ciclo: null, id_sucursal: null, id_tipo: null, id_uso: null, archivo: null };
      this.dlgSubida = true;
      var self = this;
      this.$nextTick(function () { self.$refs.formSubida && self.$refs.formSubida.resetValidation(); });
    },

    async guardar() {
      if (!this.$refs.formSubida.validate()) return;
      this.guardando = true;
      try {
        if (this.modoEdicion) {
          await this.$http.post('multimedia.recursos.update/' + this.recursoEdit.id,
            Object.assign({}, this.form, { instancia: this.inst }));
          this.showSnack('Recurso actualizado');
        } else {
          var fd = new FormData();
          fd.append('nombre', this.form.nombre); 
          fd.append('id_ciclo', this.form.id_ciclo || '');
          fd.append('id_sucursal', this.form.id_sucursal || '');
          fd.append('id_tipo', this.form.id_tipo); 
          fd.append('id_uso', this.form.id_uso);
          fd.append('id_usuario', this.idUsuario); 
          fd.append('instancia', this.inst);
          fd.append('archivo', this.form.archivo);
          await this.$http.post('multimedia.recursos.add', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
          this.showSnack('Recurso subido correctamente');
        }
        this.dlgSubida = false; this.getRecursosAdmin();
      } catch (e) {
        var msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al guardar';
        this.showSnack(msg, 'error');
      } finally { this.guardando = false; }
    },

    abrirEdicion(item) {
      this.modoEdicion = true; this.recursoEdit = item;
      this.form = { nombre: item.nombre, id_ciclo: item.id_ciclo, id_sucursal: item.id_sucursal, id_tipo: item.id_tipo, id_uso: item.id_uso };
      this.dlgSubida = true;
    },

    abrirClonar(item) { 
      this.recursoClonar = item; 
      this.cicloClon = null; 
      this.dlgClonar = true; 
    },
    
    async clonar() {
      if (!this.cicloClon) return;
      this.guardando = true;
      try {
        await this.$http.post('multimedia.recursos.clonar/' + this.recursoClonar.id, {
          id_ciclo_destino: this.cicloClon, id_usuario: this.idUsuario, instancia: this.inst,
        });
        this.dlgClonar = false; this.showSnack('Recurso clonado'); this.getRecursosAdmin();
      } catch (e) { this.showSnack('Error al clonar', 'error'); }
      finally { this.guardando = false; }
    },

    confirmarBorrar(item) { 
      this.recursoBorrar = item; 
      this.dlgBorrar = true; 
    },

    async borrar() {
      this.guardando = true;
      try {
        await this.$http.put('multimedia.recursos.delete/' + this.recursoBorrar.id, {
          id_usuario: this.idUsuario, instancia: this.inst,
        });
        this.dlgBorrar = false; this.showSnack('Recurso eliminado (borrado lógico)'); this.getRecursosAdmin();
      } catch (e) { 
        var msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al borrar';
        this.showSnack(msg, 'error'); 
      }
      finally { this.guardando = false; }
    },

    async toggleVisibilidad(item) {
      try {
        await this.$http.post('multimedia.ciclos.visibilidad/' + item.id_ciclo, {
          visible: item.visible, id_usuario: this.idUsuario, instancia: this.inst,
        });
        this.showSnack('Visibilidad actualizada');
      } catch (e) { 
        var msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al actualizar visibilidad';
        this.showSnack(msg, 'error'); 
      }
    },

    async addTipo() {
      if (!this.nuevoTipo.trim()) return;
      this.guardando = true;
      try {
        await this.$http.post('multimedia.tipos.add', { nombre: this.nuevoTipo.trim(), id_usuario: this.idUsuario, instancia: this.inst });
        this.nuevoTipo = ''; 
        this.showSnack('Tipo agregado'); 
        await this.cargarCatalogos();
      } catch (e) { 
        var msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al agregar tipo';
        this.showSnack(msg, 'error'); 
      } finally { this.guardando = false; }
    },

    async deactivateTipo(item) {
      try {
        await this.$http.put('multimedia.tipos.deactivate/' + item.id, { id_usuario: this.idUsuario, instancia: this.inst });
        this.showSnack('Tipo desactivado'); 
        await this.cargarCatalogos();
      } catch (e) {
        var msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al desactivar';
        this.showSnack(msg, 'error');
      }
    },

    async addUso() {
      if (!this.nuevoUso.trim()) return;
      this.guardando = true;
      try {
        await this.$http.post('multimedia.usos.add', { nombre: this.nuevoUso.trim(), id_usuario: this.idUsuario, instancia: this.inst });
        this.nuevoUso = ''; 
        this.showSnack('Uso agregado'); 
        await this.cargarCatalogos();
      } catch (e) {   
        var msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al agregar uso';
        this.showSnack(msg, 'error'); 
      } finally { this.guardando = false; }
    },

    async deactivateUso(item) {
      try {
        await this.$http.put('multimedia.usos.deactivate/' + item.id, { id_usuario: this.idUsuario, instancia: this.inst });
        this.showSnack('Uso desactivado'); 
        await this.cargarCatalogos();
      } catch (e) {
        var msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Error al desactivar';
        this.showSnack(msg, 'error');
      }
    },

    esImagen(url) { return /\.(jpg|jpeg|png)$/i.test(url); },

    esPdf(url) { return /\.pdf$/i.test(url); },

    getUrl(url) {
      var base = (this.$http.defaults && this.$http.defaults.baseURL) ? this.$http.defaults.baseURL.replace(/\/$/, '') : '';
      return base + url;
    },

    abrirVisor(item) {
      if (this.esPdf(item.url)) {
        // Los PDF es mejor abrirlos en nueva pestaña directo para que el navegador los renderice
        this.abrirArchivo(item.url);
      } else {
        this.recursoVisor = item;
        this.dlgVisor = true;
      }
    },

    abrirArchivo(url) { 
      window.open(this.getUrl(url), '_blank'); 
    },

    async descargarArchivo(url, nombreDefault) {
      try {
        const urlCompleta = this.getUrl(url);
        const response = await fetch(urlCompleta);
        if (!response.ok) throw new Error('Error al descargar');
        const blob = await response.blob();
        
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = nombreDefault || 'descarga'; 
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Error al descargar el archivo:", error);
        this.showSnack('Error al descargar el archivo', 'error');
      }
    },

    showSnack(text, color) { 
      this.snack = { 
        show: true, 
        text: text, 
        color: color || 'success' 
      }; 
    },
  },

  async mounted() {
    await this.cargarBase();
    await this.getRecursos();
  },
};
</script>
